import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";

import NotFound from "shared-anpost-components/components/notFound/NotFound";

// components
import ScrollToTop from "../_common/scrollToTop/ScrollToTop";
import BlankScreen from "../_common/blankScreen/blankScreen";

const DeliveryDetails = lazy(() => import("../_pages/_deliveryDetails/DeliveryDetails"));
const EditAddress = lazy(() => import("../_pages/subPages/addNewAddress/AddNewAddress"));
const DeliveryInstructions = lazy(() => import("../_pages/_deliveryInstructions/DeliveryInstructions"));
const EditDeliveryInstructions = lazy(() => import("../_pages/_editDeliveryInstructions/EditDeliveryInstructions"));
const EditNeighbour = lazy(() => import("../_pages/editNeighbour/editNeighbour"));
const EditSafePlace = lazy(() => import("../_pages/editSafePlace/editSafePlace"));
const ContactInfo = lazy(() => import("../_pages/_contactInfo/ContactInfo"));
const HomePage = lazy(() => import("../_pages/_homePage/HomePage"));

const Routes = ({ history }) => {
    return (
        <ScrollToTop>
            <Suspense fallback={<BlankScreen />}>
                <Switch>
                    {/* Root of the app display, display different component based on the path that's set in the url */}
                    {/** Overview */}
                    <Route exact path={["/", "?return=My-account/", "/Business"]} component={() => <HomePage history={history} openTab="my-deliveries" />} />

                    {/** Profile */}
                    <Route exact path="*/delivery-backup" component={() => <HomePage history={history} openTab="delivery-backup" />} />

                    {/** Marketing Preferences */}
                    <Route exact path="*/faq" component={() => <HomePage history={history} openTab="faq" />} />

                    {/* Edit address route */}
                    <Route exact path="/add-new-address" component={() => <EditAddress history={history} />} />

                    {/* Edit address route */}
                    <Route exact path="/manage-delivery-instructions" component={() => <DeliveryInstructions history={history} />} />

                    {/* Edit Deliver instructions */}
                    <Route exact path="/edit-delivery-instructions" component={() => <EditDeliveryInstructions history={history} />} />

                    {/* Edit Neighbour */}
                    <Route exact path="/edit-neighbour" component={() => <EditNeighbour history={history} />} />

                    {/* Edit Safe Place */}
                    <Route exact path="/edit-safe-place" component={() => <EditSafePlace history={history} />} />

                    {/* Contact info route */}
                    <Route exact path="/contact-information" component={() => <ContactInfo history={history} />} />

                    {/* Delivery Details route */}
                    <Route exact path="/delivery-details" component={() => <DeliveryDetails history={history} />} />

                    {/** GLOBAL HELPERS */}
                    {/** session expired */}
                    <Route exact path="/session-expired" component={() => <NotFound history={history} />} />

                    {/** session expired */}
                    <Route component={() => <NotFound history={history} error />} />
                </Switch>
            </Suspense>
        </ScrollToTop>
    );
};

export default withRouter(Routes);

// props validation
Routes.propTypes = {
    history: PropTypes.object
};
